export default "__VITE_ASSET__CC6_Yoqb__"